<template>
  <section  v-if="showPartCollections"
            class="mt-5 full-width">
    <article  class="collection-container">
          <button v-for="collection in topCollections"
                  class="button is-primary"
                  @click.stop="handleCollectionSelection(collection.id)">
          <span>{{ collection.name }}</span>
      </button>
    </article>
    <article  v-if="showFooter"
              class="is-flex is-justify-content-space-between mt-3">
      <p  class="has-text-grey has-text-weight-bold">
        {{ footerMessage }}
      </p>
      <p  class="has-text-link has-text-weight-bold"
          @click="navigateToPartCollections">
        {{ $t('goToPartCollections', { partCollections: $tc('partCollection', 2) }) }}
      </p>
    </article>
  </section>
</template>

<script setup lang="ts">
import { computed, nextTick } from "vue"
import useRouteParams from '@/composables/useRouteParams'
import { usePartCollectionsData } from "@/composables/collections/usePartCollectionsData"
import useDetailPage from "../details/useDetailPage"
import useI18n from "@/locales/useI18n"
import { usePartCollectionSearch } from '@/composables/collections/usePartCollectionSearch'
import { useBreakpoints } from '@/helpers/responsiveBreakpoints'

const { id } = useRouteParams()
const { collections, selectCollection } = usePartCollectionsData(
  id.value,
  (part: any) => part
)
const { content, showPartCollections } = useDetailPage()
const { t } = useI18n()
const {
  clearSearch: clearPartCollectionSearch,
  isSearchMode
} = usePartCollectionSearch(
  id.value,
  () => {}
)
const { width } = useBreakpoints()

const isMobile = computed(() => {
  return width.value <= 768
})
const topCollections = computed(() => {
  if (isMobile.value) return collections.value.slice(0, 3)
  return collections.value.slice(0, 6)
})
const totalCollections = computed(() => {
  return content.value?.partCollectionsCount ?? 0
})
const showFooter = computed(() => {
  if (totalCollections.value === 0) return false
  return topCollections.value.length !== totalCollections.value
})
const footerMessage = computed(() => {
  return t("mOfNShown", { 
    m: topCollections.value.length, 
    n: totalCollections.value 
  })
})

const navigateToPartCollections = () => {
  document.getElementById("PartCollections")?.scrollIntoView()
}
const handleCollectionSelection = (collectionId: number) => {
  selectCollection(collectionId)
  if (isSearchMode.value) clearPartCollectionSearch()
  nextTick(() => navigateToPartCollections())
}
</script>

<style scoped>
.collection-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.collection-container .button span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

@media screen and (max-width: 768px) {
  .collection-container {
    display: block;
    width: 100%;
  }

  .collection-container .button {
    display: block;
    width: 75%;
    margin: 0 auto 0.5rem;
  }

  .collection-container .button span {
    display: block;
  }

  .collection-container .button:last-child {
    margin-bottom: 0;
  }
}

@media screen and (min-width: 769px) {
  .collection-container .button {
    flex: 0 0 10rem;
    overflow: hidden;
    max-width: 30vw;
  }
}

.has-text-link {
  cursor: pointer;
}
</style>